(function(){
  // Cada sección incluye este script: sin el cerrojo, los eventos se atan una vez por sección.
  if (window.__casaAlma) return;
  window.__casaAlma = true;

  // Igual que el filtro handleize de Liquid, para comparar etiquetas.
  function handle(s){
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function money(n){ return 'Bs ' + n.toLocaleString('es-BO'); }
  // Horizon repone durante 10 s el contador que guardó: tras agregar por fuera, pisaría al del servidor.
  function olvidarContador(){ try { sessionStorage.removeItem('cart-count'); } catch (e) {} }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  // Fecha local: toISOString es UTC y después de las 20:00 de Bolivia ya es el día siguiente.
  function fechaLocal(d){ return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

  // ---------- Slider ----------
  function initSlider(root){
    var slides = root.querySelectorAll('.ca-slide'), dots = root.querySelectorAll('.ca-slider__dot');
    var i = 0, ms = parseInt(root.dataset.interval || '6', 10) * 1000, t;
    function show(n){ i = (n + slides.length) % slides.length;
      slides.forEach(function(s,k){ s.classList.toggle('is-active', k === i); });
      dots.forEach(function(d,k){ d.classList.toggle('is-active', k === i); }); }
    function play(){ clearInterval(t); if (slides.length > 1) t = setInterval(function(){
      if (!root.isConnected) { clearInterval(t); return; }
      if (document.querySelector('.ca-modal[open]')) return;
      show(i + 1); }, ms); }
    root.querySelector('[data-prev]') && root.querySelector('[data-prev]').addEventListener('click', function(){ show(i - 1); play(); });
    root.querySelector('[data-next]') && root.querySelector('[data-next]').addEventListener('click', function(){ show(i + 1); play(); });
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ show(k); play(); }); });
    root.addEventListener('mouseenter', function(){ clearInterval(t); });
    root.addEventListener('mouseleave', play);
    show(0); play();
  }

  // ---------- Pedido repostería ----------
  function initPedido(root){
    var qty = {}, mode = 'encargo', day = 'Sábado', delivery = 'Retiro en tienda';
    var phone = root.dataset.whatsapp;
    var dateInput = root.querySelector('[data-date]');
    var min = new Date(Date.now() + 48 * 3600e3);
    var minISO = fechaLocal(min);
    if (dateInput) dateInput.min = minISO;
    var minLabel = root.querySelector('[data-min-label]');
    if (minLabel) minLabel.textContent = min.toLocaleDateString('es-BO', { weekday:'long', day:'numeric', month:'long' });
    if (!phone) root.querySelectorAll('[data-wa]').forEach(function(b){ b.hidden = true; });

    function render(){
      var lines = [], total = 0;
      root.querySelectorAll('[data-item]').forEach(function(row){
        var id = row.dataset.item, q = qty[id] || 0, p = parseFloat(row.dataset.price);
        row.querySelector('[data-q]').textContent = q;
        if (q) { lines.push({ id:row.dataset.variant, name:row.dataset.name, q:q, sub:q * p }); total += q * p; }
      });
      var box = root.querySelector('[data-lines]');
      box.textContent = '';
      if (!lines.length) {
        var vacio = document.createElement('p');
        vacio.style.cssText = 'margin:0;font-size:14px;color:var(--ca-muted)';
        vacio.textContent = 'Sumá productos del menú con el botón +.';
        box.appendChild(vacio);
      }
      lines.forEach(function(l){
        var fila = document.createElement('div'), nombre = document.createElement('span'), sub = document.createElement('strong');
        fila.className = 'ca-row'; fila.style.cssText = 'padding:7px 0;font-size:14px';
        nombre.style.flex = '1'; nombre.textContent = l.q + ' × ' + l.name;
        sub.textContent = money(l.sub);
        fila.appendChild(nombre); fila.appendChild(sub); box.appendChild(fila);
      });
      root.querySelector('[data-total]').textContent = money(total);
      root.querySelectorAll('[data-only]').forEach(function(el){ el.hidden = el.dataset.only !== mode; });
      root.querySelector('[data-submit]').textContent = mode === 'encargo' ? 'Confirmar encargo' : 'Consultar disponibilidad';
      root._lines = lines; root._total = total;
    }
    root.addEventListener('click', function(e){
      var b = e.target.closest('button'); if (!b) return;
      var row = b.closest('[data-item]');
      if (b.hasAttribute('data-inc')) { qty[row.dataset.item] = (qty[row.dataset.item] || 0) + 1; render(); }
      if (b.hasAttribute('data-dec')) { qty[row.dataset.item] = Math.max(0, (qty[row.dataset.item] || 0) - 1); render(); }
      if (b.dataset.mode) { mode = b.dataset.mode; root.querySelectorAll('[data-mode]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); }); render(); }
      if (b.dataset.day) { day = b.dataset.day; root.querySelectorAll('[data-day]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); }); }
      if (b.dataset.delivery) { delivery = b.dataset.delivery; root.querySelectorAll('[data-delivery]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); }); render(); }
      if (b.hasAttribute('data-submit')) submit();
      if (b.hasAttribute('data-wa')) openWa(msg());
    });
    function msg(){
      var t = 'Hola Casa Alma! ';
      t += mode === 'encargo' ? 'Quiero hacer un encargo para el ' + (dateInput.value || '(fecha a definir)') + ' · ' + delivery + ':\n' : 'Quiero consultar disponibilidad para retirar el ' + day + ':\n';
      (root._lines || []).forEach(function(l){ t += '• ' + l.q + ' × ' + l.name + '\n'; });
      return t + 'Total: ' + money(root._total || 0);
    }
    function openWa(text){ window.open('https://wa.me/' + phone + '?text=' + encodeURIComponent(text), '_blank'); }
    function submit(){
      var lines = root._lines || [];
      if (!lines.length) { alert('Agregá al menos un producto.'); return; }
      if (mode === 'listo') {
        if (!phone) { alert('Por ahora la consulta de disponibilidad no está disponible.'); return; }
        openWa(msg()); return;
      }
      if (!dateInput.value) { alert('Elegí la fecha de entrega (mínimo 48 h).'); return; }
      // El atributo min no frena una fecha escrita a mano: acá no hay submit de formulario.
      if (dateInput.value < minISO) { alert('Necesitamos 48 h de anticipación. Elegí una fecha desde el ' + minISO + '.'); return; }
      fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ items: lines.map(function(l){ return { id:+l.id, quantity:l.q, properties:{ 'Fecha de entrega':dateInput.value, 'Entrega':delivery } }; }) })
      }).then(function(r){ if (!r.ok) throw r; return fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ attributes:{ 'Fecha de entrega':dateInput.value, 'Entrega':delivery } }) }); })
        .then(function(){ olvidarContador(); window.location.href = '/cart'; })
        .catch(function(){ alert('No pudimos agregar al carrito. Probá de nuevo o escribinos.'); });
    }
    render();
  }

  // ---------- Buscador de regalos ----------
  // Lee la colección completa de products.json: en Liquid el bucle se corta en 50 productos.
  function initRegalos(root){
    var occ = '', productos = [], visibles = 24;
    var budget = root.querySelector('[data-budget]'), label = root.querySelector('[data-budget-label]');
    var grid = root.querySelector('[data-grid]'), empty = root.querySelector('[data-empty]'), more = root.querySelector('[data-more]');
    var loading = root.querySelector('[data-loading]');

    function tarjeta(p){
      var a = document.createElement('a'), caja = document.createElement('div'), body = document.createElement('div');
      a.className = 'ca-card ca-gift'; a.href = root.dataset.collection + '/products/' + p.handle;
      caja.className = 'ca-gift__img';
      if (p.img) {
        var img = document.createElement('img');
        img.className = 'ca-img'; img.loading = 'lazy'; img.alt = p.title;
        img.src = p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=500';
        caja.appendChild(img);
      }
      body.className = 'ca-gift__body';
      if (p.tipo) { var k = document.createElement('span'); k.className = 'ca-kicker'; k.style.cssText = 'font-size:11px;color:#1F5E63'; k.textContent = p.tipo; body.appendChild(k); }
      var t = document.createElement('strong'); t.style.fontSize = '16px'; t.textContent = p.title;
      body.appendChild(t);
      if (p.texto) { var d = document.createElement('p'); d.className = 'ca-prod__text'; d.textContent = p.texto; body.appendChild(d); }
      var pie = document.createElement('div'); pie.className = 'ca-prod__pie';
      var m = document.createElement('span'); m.className = 'ca-prod__precio'; m.textContent = money(p.price);
      var boton = document.createElement('span'); boton.className = 'ca-btn ca-btn--chico'; boton.style.cssText = 'background:#1F5E63;color:#fff'; boton.textContent = 'Armar caja';
      pie.appendChild(m); pie.appendChild(boton); body.appendChild(pie);
      a.appendChild(caja); a.appendChild(body);
      return a;
    }
    function filter(){
      var max = +budget.value; label.textContent = 'Bs ' + max;
      var ok = productos.filter(function(p){ return p.price <= max && (!occ || p.tags.indexOf(occ) > -1); });
      grid.textContent = '';
      ok.slice(0, visibles).forEach(function(p){ grid.appendChild(tarjeta(p)); });
      empty.hidden = ok.length > 0;
      more.hidden = ok.length <= visibles;
    }
    function chips(){
      // Una ocasión sin productos sería un botón que siempre da vacío: se oculta.
      root.querySelectorAll('[data-occ]').forEach(function(b){
        b.hidden = !productos.some(function(p){ return p.tags.indexOf(b.dataset.occ) > -1; });
        b.addEventListener('click', function(){
          occ = occ === b.dataset.occ ? '' : b.dataset.occ; visibles = 24;
          root.querySelectorAll('[data-occ]').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.occ === occ); });
          filter();
        });
      });
    }
    function cargar(pagina){
      return fetch(root.dataset.collection + '/products.json?limit=250&page=' + pagina).then(function(r){
        if (!r.ok) throw r; return r.json();
      }).then(function(d){
        d.products.forEach(function(p){
          var disponibles = p.variants.filter(function(v){ return v.available && parseFloat(v.price) > 0; });
          if (!disponibles.length) return;
          productos.push({ title:p.title, handle:p.handle, tags:p.tags.map(handle),
            price:Math.min.apply(null, disponibles.map(function(v){ return parseFloat(v.price); })),
            img:p.images[0] && p.images[0].src, tipo:p.product_type,
            texto:String(p.body_html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 70) });
        });
        if (d.products.length === 250) return cargar(pagina + 1);
      });
    }
    label.textContent = 'Bs ' + budget.value;
    budget.addEventListener('input', function(){ visibles = 24; filter(); });
    more.addEventListener('click', function(){ visibles += 24; filter(); });
    if (!root.dataset.collection) { loading.hidden = true; empty.hidden = false; return; }
    cargar(1).catch(function(){}).then(function(){ loading.hidden = true; chips(); filter(); });
  }

  // ---------- Aviso ----------
  function toast(texto){
    var t = document.createElement('div');
    t.className = 'ca-toast'; t.setAttribute('role', 'status'); t.textContent = texto;
    document.body.appendChild(t);
    setTimeout(function(){ t.remove(); }, 2200);
  }
  function guardado(clave, valor){
    try { if (valor === undefined) return localStorage.getItem(clave); localStorage.setItem(clave, valor); } catch (e) { return null; }
  }

  // ---------- Agregar al carrito ----------
  // Se recarga para que el contador y el carrito lateral de Horizon salgan del servidor.
  function agregar(items, destino){
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ items:items }) })
      .then(function(r){ if (!r.ok) throw r; })
      .then(function(){
        olvidarContador();
        if (destino) { window.location.href = destino; return; }
        try { sessionStorage.setItem('caAviso', 'Agregado al carrito'); } catch (e) {}
        window.location.reload();
      })
      .catch(function(){ toast('No pudimos agregarlo. Probá de nuevo o escribinos.'); });
  }
  try {
    var aviso = sessionStorage.getItem('caAviso');
    if (aviso) { sessionStorage.removeItem('caAviso'); toast(aviso); }
  } catch (e) {}

  // ---------- Lista de deseos ----------
  // Vive en este navegador: las cuentas de cliente de Shopify no guardan listas.
  function favoritos(){
    try { return JSON.parse(guardado('caFavoritos') || '[]'); } catch (e) { return []; }
  }
  function pintarFavoritos(){
    var lista = favoritos();
    document.querySelectorAll('[data-ca-fav]').forEach(function(b){
      var es = lista.indexOf(b.dataset.caFav) > -1;
      b.classList.toggle('is-fav', es); b.setAttribute('aria-pressed', es);
      if (b.hasAttribute('data-ca-fav-texto')) b.textContent = es ? '♥ En mi lista de deseos' : '♡ Guardar en mi lista de deseos';
      else b.textContent = es ? '♥' : '♡';
    });
    document.querySelectorAll('[data-ca-fav-count]').forEach(function(s){ s.textContent = lista.length ? '· ' + lista.length : ''; });
  }
  function initLista(root){
    var lista = favoritos(), grid = root.querySelector('[data-grid]'), vacio = root.querySelector('[data-vacio]'), comp = root.querySelector('[data-compartir]');
    vacio.hidden = lista.length > 0;
    Promise.all(lista.map(function(h){
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(ps){
      ps = ps.filter(Boolean);
      ps.forEach(function(p){
        var a = document.createElement('a'), caja = document.createElement('div'), body = document.createElement('div');
        a.className = 'ca-card ca-gift'; a.href = p.url;
        caja.className = 'ca-gift__img';
        if (p.featured_image) { var img = document.createElement('img'); img.className = 'ca-img'; img.loading = 'lazy'; img.alt = p.title; img.src = p.featured_image; caja.appendChild(img); }
        body.className = 'ca-gift__body';
        var t = document.createElement('strong'); t.textContent = p.title;
        var m = document.createElement('span'); m.className = 'ca-prod__precio'; m.textContent = money(p.price / 100);
        body.appendChild(t); body.appendChild(m); a.appendChild(caja); a.appendChild(body); grid.appendChild(a);
      });
      vacio.hidden = ps.length > 0;
      if (ps.length) {
        comp.hidden = false;
        comp.href = 'https://wa.me/?text=' + encodeURIComponent('Mi lista de deseos en Casa Alma:\n' + ps.map(function(p){ return '• ' + p.title + ': ' + location.origin + p.url; }).join('\n'));
      }
    });
  }

  // ---------- Placa para story ----------
  var modal;
  function crearModal(){
    modal = document.createElement('dialog');
    modal.className = 'ca ca-modal';
    modal.innerHTML = '<div class="ca-modal__in"><div class="ca-story" data-placa><div class="ca-story__tope"><span>Casa Alma</span></div><div class="ca-story__foto" data-foto></div><div><div class="ca-h" style="font-size:26px" data-titulo></div><div style="font-size:13.5px;font-weight:600;margin-top:4px" data-precio></div></div></div>' +
      '<div><h2 class="ca-h" style="font-size:29px;margin-bottom:8px">Compartir en redes</h2><p style="margin:0;font-size:14.5px;line-height:1.55;color:var(--ca-muted)">Sacale captura a la placa para tu story. El texto ya trae los hashtags, listo para pegar.</p><textarea data-texto aria-label="Texto para compartir"></textarea><div class="ca-acciones" style="align-items:center"><button type="button" class="ca-btn ca-btn--chico" style="background:var(--ca-ink);color:#fff" data-copiar>Copiar texto</button><a class="ca-btn ca-btn--ghost ca-btn--chico" style="color:var(--ca-ink)" target="_blank" rel="noopener" data-wa-enviar>Enviar por WhatsApp</a><button type="button" class="ca-fav-link" data-cerrar>Cerrar</button></div></div></div>';
    document.body.appendChild(modal);
    var texto = modal.querySelector('[data-texto]'), wa = modal.querySelector('[data-wa-enviar]');
    function enlazar(){ wa.href = 'https://wa.me/?text=' + encodeURIComponent(texto.value); }
    texto.addEventListener('input', enlazar);
    modal._enlazar = enlazar;
    modal.querySelector('[data-cerrar]').addEventListener('click', function(){ modal.close(); });
    modal.addEventListener('click', function(e){ if (e.target === modal) modal.close(); });
    modal.querySelector('[data-copiar]').addEventListener('click', function(){
      (navigator.clipboard ? navigator.clipboard.writeText(texto.value) : Promise.reject()).then(function(){ toast('Texto copiado'); }, function(){ texto.select(); toast('Seleccioná y copiá el texto'); });
    });
  }
  function abrirPlaca(b){
    if (!modal) crearModal();
    var d = b.dataset, foto = modal.querySelector('[data-foto]');
    modal.querySelector('[data-placa]').style.background = d.color || '#2A2320';
    modal.querySelector('[data-titulo]').textContent = d.title;
    modal.querySelector('[data-precio]').textContent = d.precio ? d.precio + ' · pedidos por WhatsApp' : 'Pedidos por WhatsApp';
    foto.textContent = '';
    if (d.img) { var img = document.createElement('img'); img.src = d.img; img.alt = d.title; foto.appendChild(img); }
    modal.querySelector('[data-texto]').value = '✨ ' + d.title + (d.precio ? ' — ' + d.precio : '') + '.\n\nPedidos por WhatsApp o en la web: ' + d.url + '\n\n#CasaAlma #HechoEnBolivia';
    modal._enlazar();
    modal.showModal();
  }

  // ---------- Personalizar en la ficha ----------
  function initPerso(root){
    root.querySelectorAll('[data-min-48]').forEach(function(i){ i.min = fechaLocal(new Date(Date.now() + 48 * 3600e3)); });
  }
  function alternarCampo(b){
    var activo = b.getAttribute('aria-pressed') !== 'true', campo = b.closest('[data-ca-perso]').querySelector('[data-para="' + b.dataset.campo + '"]');
    b.setAttribute('aria-pressed', activo);
    // Deshabilitado no viaja en el pedido: sin esto quedaría una propiedad vacía en la línea.
    campo.hidden = !activo; campo.disabled = !activo;
    if (activo) campo.focus();
  }

  // ---------- Inscripción a clase ----------
  function initClase(root){
    var precio = root.querySelector('[data-precio]');
    root.querySelectorAll('input[type="radio"]').forEach(function(r){
      r.addEventListener('change', function(){ precio.textContent = r.dataset.precioTexto; });
    });
    var boton = root.querySelector('[data-confirmar]');
    boton.addEventListener('click', function(){
      var v = root.querySelector('input[name="variante"]:checked') || root.querySelector('input[type="hidden"][name="variante"]');
      if (!v) { toast('Elegí una modalidad.'); return; }
      var items = [{ id:+v.value, quantity:1 }], kit = root.querySelector('[data-kit]');
      if (kit && kit.checked) items.push({ id:+kit.dataset.kit, quantity:1 });
      boton.disabled = true;
      agregar(items, '/cart').then(function(){ boton.disabled = false; });
    });
  }

  // Delegado: las tarjetas también nacen después, y el editor repinta secciones.
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-ca-fav],[data-ca-story],[data-ca-add],[data-campo]');
    if (!b) return;
    if (b.dataset.caFav) {
      var lista = favoritos(), i = lista.indexOf(b.dataset.caFav);
      if (i > -1) lista.splice(i, 1); else lista.push(b.dataset.caFav);
      guardado('caFavoritos', JSON.stringify(lista));
      pintarFavoritos();
      toast(i > -1 ? 'Quitado de tu lista' : 'Guardado en tu lista');
    } else if (b.hasAttribute('data-ca-story')) {
      abrirPlaca(b);
    } else if (b.dataset.caAdd) {
      b.disabled = true;
      agregar([{ id:+b.dataset.caAdd, quantity:1 }]).then(function(){ b.disabled = false; });
    } else if (b.dataset.campo) {
      alternarCampo(b);
    }
  });

  var INICIOS = { '[data-ca-slider]':initSlider, '[data-ca-order]':initPedido, '[data-ca-gifts]':initRegalos, '[data-ca-lista]':initLista, '[data-ca-perso]':initPerso, '[data-ca-clase]':initClase };
  function init(scope){
    Object.keys(INICIOS).forEach(function(sel){
      scope.querySelectorAll(sel).forEach(function(el){
        if (el.dataset.caListo) return;
        el.dataset.caListo = '1';
        INICIOS[sel](el);
      });
    });
  }
  init(document);
  pintarFavoritos();
  // En el celular la barra de mundos se desliza: que el mundo actual quede a la vista.
  var mundo = document.querySelector('.ca-tab.is-active');
  if (mundo) mundo.parentNode.scrollLeft = mundo.offsetLeft - mundo.parentNode.offsetLeft - 20;
  // El editor del tema vuelve a pintar la sección al cambiar un ajuste.
  document.addEventListener('shopify:section:load', function(e){ init(e.target); pintarFavoritos(); });
})();
